import React from 'react';
import Iframe from 'react-iframe';

import SuccessModalWrapper from './style';

const SuccessModal = props => (
  <SuccessModalWrapper>
    <Iframe
      url={`${process.env.SITE_URL}/cgu.html`}
      height="100%"
      width="100%"
      frameBorder={0}
      position="relative"
    />
  </SuccessModalWrapper>
);
export default SuccessModal;
